const GetNokCustType = async (props) => { 
    const _res = await props._api({
        ...props,
        method: "get",
        endpoint: "/api/LookUpValue/v2/nok_custtype",
        param: "",
        data: null,
      });

    return _res;
}

export default GetNokCustType;